export default __webpack_public_path__ + "media/images/bordleft-onglet-b36d4b95c2f4c42828e35426f6475856.png";